// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__1AEUA","white":"menu_white__33Osw","black":"menu_black__2Y7uy"};